// takes a string of bytes and returns a human readable string
export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const capitalizeString = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const formatNodes = (nodes: any) => {
  const formattedNodes: any = {};
  const rootNodeChildNodeIds: string[] = nodes["ROOT"].nodes;

  rootNodeChildNodeIds.forEach((nodeId: string) => {
    const node = nodes[nodeId];

    formattedNodes[nodeId] = { id: nodeId, ...node };

    formattedNodes[nodeId].props.id = nodeId;
  });

  // also add the root node
  formattedNodes["ROOT"] = {
    id: "ROOT",
    ...nodes["ROOT"],
  };

  return formattedNodes;
};
